import url from '@/utils/url';

/** URL query 优先，其次 HTML 注入的 pageConfig */
export const resolveBallPageId = (): string =>
    url.get('pageId') || window.__PAGE_CONFIG__?.pageId || '';
